import { BrowserRouter, Route, Link, Routes } from 'react-router-dom';
import './App.css';
import { Container, Row, Col } from 'react-bootstrap';
import { useEffect } from 'react';
import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from '@azure/msal-react';
import 'bootstrap/dist/css/bootstrap.min.css'

// General imports
import Navbar from './components/Misc/NavBar';
import FlyerMakerHeader from './components/Misc/FlyerMakerHeader';
import './font.css';
import FlyerMakerLayout from './components/FlyerMakerLayout';
import SignInButton from './components/SignInButton';

// Campaign imports
import CampaignTable from './components/Campaign/CampaignTable';
import CampaignForm from './components/Campaign/CampaignForm';
import Campaign from './components/Campaign/Campaign';
//import Campaign from './components/_Campaign/Campaign';

// Brand imports
import BrandTable from './components/Brands/BrandTable'
import BrandEdit from './components/Brands/EditBrand';

// Product imports
import ProductSearch from './components/Products/ProductSearch';
import ProductForm from './components/Products/ProductForm';
//import { useEffect, useState } from 'react';

// Promos imports
import PromoTable from './components/Promos/PromoTable';
import PromoForm from './components/Promos/PromoForm';
import PromoEditor from './components/Promos/PromoEditor';

//REMOVE TEMP IMPORTS
import TestGrid from './components/_Campaign/Grid/test_grid';
import TestCampaignProductForm from './components/_Campaign/CampaignProductForm/CampaignProductFormTest.tsx';

function App({ instance }) {
  const authEnabled = process.env.REACT_APP_AUTH_ENABLED !== 'false';
  
  if (!authEnabled) {
    // Skip MSAL entirely, render app directly
    return (
      <div className="App">
        <BrowserRouter>
          <FlyerMakerLayout>
            <Routes>
              <Route path="/" element={<CampaignTable />} />
              <Route path="/new_campaign" element={<CampaignForm />} />
              <Route path="/edit_campaign" element={<Campaign />} />
              <Route path="/brands" element={<BrandTable />} />
              <Route path="/edit_brand" element={<BrandEdit />} />
              <Route path="/products" element={<ProductSearch />} />
              <Route path="/edit_product" element={
                  <Container>
                      <Row className="mb-3">
                          <Col lg={4} className="text-start">
                              <h2>Products</h2>
                          </Col>
                          <Col xs={8} className="text-end align-self-center">
                              <Link to='/products' style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", padding: "5px 10px"}} id="backToBrands">Done</Link>
                          </Col>
                      </Row>
                      <hr />
                      <ProductForm />
                  </Container>
              } />
              <Route path="/promos" element={<PromoTable />} />
              <Route path="/new_promo" element={<PromoForm />} />
              <Route path="/edit_promo" element={<PromoEditor />} />
            </Routes>
          </FlyerMakerLayout>
        </BrowserRouter>
      </div>
    );
  }
  return (
    <MsalProvider instance={instance}>
    <div className="App">
      <AuthenticatedTemplate>
          <BrowserRouter>
              <FlyerMakerLayout>
                <Routes>
                  <Route path="/" element={<CampaignTable />} />
                  <Route path="/new_campaign" element={<CampaignForm />} />
                  <Route path="/edit_campaign" element={<Campaign />} />
                  <Route path="/brands" element={<BrandTable />} />
                  <Route path="/edit_brand" element={<BrandEdit />} />
                  <Route path="/products" element={<ProductSearch />} />
                  <Route path="/edit_product" element={
                      <Container>
                          <Row className="mb-3">
                              <Col lg={4} className="text-start">
                                  <h2>Products</h2>
                              </Col>
                              <Col xs={8} className="text-end align-self-center">
                                  <Link to='/products' style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", padding: "5px 10px"}} id="backToBrands">Done</Link>
                              </Col>
                          </Row>
                          <hr />
                          <ProductForm />
                      </Container>
                  } />
                  <Route path="/promos" element={<PromoTable />} />
                  <Route path="/new_promo" element={<PromoForm />} />
                  <Route path="/edit_promo" element={<PromoEditor />} />
                  {/*<Route path="/test-grid" element={<TestGrid />} />
                  <Route path="/test-campaign" element={<TestCampaignProductForm />} />*/}
                </Routes>
              </FlyerMakerLayout>
          </BrowserRouter>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div className="App" style={{fontFamily: 'Trade Gothic'}}>
          <FlyerMakerHeader />
          <Container>
            <Row className="mb-3 mt-3">
              <Col>
                <h2 style={{textAlign: 'center'}}>Sign in to access Flyermaker</h2>
              </Col>
            </Row>
            <hr></hr>
            <div className="d-flex justify-content-center">
              <SignInButton />
            </div>
          </Container>
        </div>
      </UnauthenticatedTemplate>
    </div>
    </MsalProvider>
  );
}

export default App;
